import { render, staticRenderFns } from "./ProjectModalNotifications.vue?vue&type=template&id=6fbaba97&scoped=true&"
import script from "./ProjectModalNotifications.vue?vue&type=script&lang=js&"
export * from "./ProjectModalNotifications.vue?vue&type=script&lang=js&"
import style0 from "./ProjectModalNotifications.vue?vue&type=style&index=0&id=6fbaba97&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fbaba97",
  null
  
)

export default component.exports